import { UserSegmentApiModel } from '@cxb/editor-stb-api';
import { UserSegment, UserSegmentType } from '../../domain/user-segment';

export const mapUserSegmentsApiToDomain = (apiModels: UserSegmentApiModel[]): UserSegment[] => {
  return apiModels.map((apiModel: UserSegmentApiModel) => ({
    id: apiModel.id,
    name: (() => {
      switch (apiModel.name) {
        case 'anonymous':
          return UserSegmentType.Anonymous;
        case 'prospect':
          return UserSegmentType.Prospect;
        case 'normal':
          return UserSegmentType.Normal;
        case 'pending-churn':
          return UserSegmentType.PendingChurn;
        case 'dunning':
          return UserSegmentType.Dunning;
        case 'churned':
          return UserSegmentType.Churned;
        default:
          return undefined;
      }
    })(),
  }));
};
